import React from 'react';
import { useImageSearchResult } from '../hooks/useImageSearchResult';
import { SearchResultItem, SearchResultItemProps } from './SearchResultItem';
import { LoadMoreBumper } from '@cube3/ui/src/utils/withLazyLoad';
import { LinearProgress } from '@material-ui/core';
import { Typography } from '@cube3/cubicle/src/core/atoms/Typography';

interface Props extends Pick<SearchResultItemProps, 'disableNavigation'> {
  query: string;
}

export const SearchResult = ({ query, disableNavigation }: Props) => {
  const { results, loading, canLoadMore, loadMore } =
    useImageSearchResult(query);

  return (
    <>
      {loading && <LinearProgress variant="query" />}
      {!loading && !results?.length && (
        <div style={{ padding: 16 }}>
          <Typography color="dark" colorVariant="03">
            No results found.
          </Typography>
        </div>
      )}
      {results?.length
        ? results.map((rs) => (
          <SearchResultItem key={rs.id} resource={rs} query={query} disableNavigation={disableNavigation} />
        ))
        : null}
      {canLoadMore && (
        <LoadMoreBumper
          once={false}
          callback={(visible) => (visible ? loadMore() : undefined)}
        />
      )}
    </>
  );
};
